import React, { useContext } from "react";
import { Progress } from "antd";
import { GlobalLoaderContext } from "../utils/GlobalLoaderContext";
import { CloseCircleFilled } from "@ant-design/icons";
import "../globalLoader.css";
const GlobalLoader = () => {
  const { loading, percent, stopLoadingCross, message } =
    useContext(GlobalLoaderContext);

  // if (!loading) return null;

  return (
    <div className={`global-loader-container ${loading ? "show" : ""}`}>
      <React.Fragment>
        <div className="global-loader-header">
          <span className="global-loader-title">
            {message ? message : "Refresing Accounts:"} {percent}%
          </span>
          <span onClick={stopLoadingCross} className="global-loader-close">
            <CloseCircleFilled />
          </span>
        </div>
        <Progress
          percent={percent}
          size="small"
          strokeColor="#2a3da3"
          showInfo={false}
          strokeWidth={12}
          className="global-loader-progress"
        />
      </React.Fragment>
    </div>
  );
};

export default GlobalLoader;
